import React from 'react';
import FlexPanel from '../FlexPanel';
import VimeoEmbed from '../video/VimeoEmbed';

const ReportTraining = () => {
  const embed = url => {
    return (
      <iframe
        width="100%"
        height="480"
        src={url}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  };

  return (
    <>
      <p style={{ fontSize: '16px' }}>
        The following training videos cover basic usage of the reporting tools found in Blaze.
      </p>
      <FlexPanel header="Basics of Reporting" className="mb-3">
        <VimeoEmbed height='480px' id='739733000' />
      </FlexPanel>
      <FlexPanel header="Sorting & Filtering" className="mb-3">
        <VimeoEmbed height='480px' id='739733046' />
      </FlexPanel>
      <FlexPanel header="Layouts & Grouping" className="mb-3">
        <VimeoEmbed height='480px' id='739733015' />        
      </FlexPanel>
      <FlexPanel header="Sharing & Exporting" className="mb-3">
        <VimeoEmbed height='480px' id='739733027' />
      </FlexPanel>
    </>
  );
};

export default ReportTraining;
